import { writable } from "svelte/store";
export const emptyNotification = { message: "", level: "" };
export const storeNotification = writable(emptyNotification);
export var Level;
(function (Level) {
    Level["INFO"] = "info";
    Level["WARNING"] = "warning";
    Level["ERROR"] = "error";
})(Level || (Level = {}));
export var Position;
(function (Position) {
    Position["TOP"] = "top";
    Position["BOTTOM"] = "bottom";
})(Position || (Position = {}));
export function addNotificationInfo(inMessage) {
    storeNotification.set({ message: inMessage, level: Level.INFO });
}
export function addNotificationWarning(inMessage) {
    storeNotification.set({ message: inMessage, level: Level.WARNING });
}
export function addNotificationError(inMessage) {
    storeNotification.set({ message: inMessage, level: Level.ERROR });
}
